export default {
  listProfiles: [],
  profile: {
    nome: '',
    roles: [],
  },
  systemPermission: [],
}
